var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1499C14.0711 16.1499 15.75 14.471 15.75 12.3999C15.75 10.3288 14.0711 8.6499 12 8.6499C9.92893 8.6499 8.25 10.3288 8.25 12.3999C8.25 14.471 9.92893 16.1499 12 16.1499Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9781 19.9002C15.3076 21.0094 13.3145 21.5288 11.3151 21.3763C9.31573 21.2237 7.42456 20.4077 5.94169 19.0579C4.45883 17.7081 3.4692 15.9018 3.12984 13.9255C2.79048 11.9492 3.12083 9.91621 4.06846 8.14906C5.0161 6.3819 6.52674 4.98182 8.3607 4.17098C10.1947 3.36014 12.2469 3.18498 14.1917 3.67329C16.1365 4.1616 17.8626 5.28542 19.096 6.86641C20.3294 8.44741 20.9995 10.395 21 12.4002C21 14.4721 20.25 16.1502 18.375 16.1502C16.5 16.1502 15.75 14.4721 15.75 12.4002V8.65023",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.97b2704077b897817450b492d93ff0a5.svg";
export { ForwardRef as ReactComponent };